import { APP_INITIALIZER, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const APP_INITIALIZERS = [
  {
    provide: APP_INITIALIZER,
    useFactory: () => {
      const translateService = inject(TranslateService);
      return () => translateService.use('en');
    },
    multi: true,
  },
];
